<template>
  <v-app-bar :class="{'fin-top-navigation': true, border: border}"
             :color="isRoot ? $finColors.primaryDark : $finColors.background "
             :dark="dark"
             :height="prominent ? undefined : '56px'"
             :prominent="prominent"
             :shrink-on-scroll="prominent"
             :style="style"
             app
             elevation="0"
             v-scroll="onScroll">

    <template #extension v-if="hasExtension">
      <PortalTarget :name="'topnav_extension'"/>
    </template>

    <v-btn @click="$router.go(-1)"
           icon
           v-if="!isFinHub && !isNewTab">
      <v-icon>icon-arrow-link-left</v-icon>
    </v-btn>

    <v-btn @click="closeWindow"
           text
           v-if="!isFinHub && isNewTab"
           class="pl-0 pr-1 mr-2">
      <v-icon>icon-arrow-link-left</v-icon>
      Zurück zur Liste
    </v-btn>

    <template v-if="currentCrumb && !isFinHub && !isNewTab">
      <v-toolbar-title class="fin-toolbartitle" v-if="prominent">
        <PortalTarget :name="'topnav_primary'">
          <div class="root-title d-flex">
            <v-icon :class="`fin-color-primary-light--text mr-${iconSpacing} my-auto`"
                    v-if="currentCrumb.meta.icon"
                    :size="fontSize < 20 ? 20 : fontSize">
              {{ currentCrumb.meta.icon }}
            </v-icon>
            <span :style="{fontSize: fontSize+'px', marginTop}"
                  class="my-auto"
                  style="margin-top: 6px;">
              {{ crumbName(currentCrumb) }}
            </span>
          </div>
        </PortalTarget>
      </v-toolbar-title>
      <v-toolbar-title v-else class="pl-0">
        <v-breadcrumbs :dark="dark"
                       :items="filteredCrumbs"
                       class="breadcrumbs">
          <v-breadcrumbs-item :to="{name: item.name}"
                              exact
                              slot="item"
                              slot-scope="{ item }">
            <PortalTarget :name="'breadcrumb_'+item.name">
              {{ crumbName(item) }}
            </PortalTarget>
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-toolbar-title>
    </template>

    <v-spacer/>

    <v-btn :to="{name: 'finSpeaker'}"
           class="main-menuitem-finSpeaker"
           @click="finSpeakerClicked"
           icon
           v-if="$vuetify.breakpoint.xsOnly">
      <v-icon class="nav-icon">icon-notification</v-icon>
    </v-btn>

    <fin-assets-name-isin-autocomplete v-if="$vuetify.breakpoint.smAndUp"
                                       class="search"
                                       :custom-result-mapping="customSearchResultMapping"
                                       style="max-width: 350px;"
                                       asset-type="ALL"
                                       instant-clear-selection
                                       @click.native="searchBarClicked"
                                       @input="val => handleSearchResult(val)"/>


    <fin-language-switcher v-if="!hideLanguageSwitcher"/>

    <template v-if="$vuetify.breakpoint.smAndUp">
      <v-divider inset
                 vertical/>

      <!-- Navigation: Benachrichtigung-->
      <v-menu offset-y
              v-if="speakerMessages && speakerMessages.length>0"
              content-class="speaker-menu-content">
        <template #activator="{ on }">
          <v-btn class="mx-4 main-menuitem-finSpeaker"
                 icon text
                 @click="finSpeakerClicked"
                 v-on="on">
            <v-badge
              bordered
              color="fin-color-accent-red"
              :content="speakerMessages.length + (speakerNextToken ? '+' : '')"
              style="min-width: 18px; height: 18px; "
            >
              <v-icon>icon-notification</v-icon>
            </v-badge>
          </v-btn>
        </template>

        <fin-speaker-messages :messages="speakerMessages"
                              short-text-preview
                              @speakerMsgClicked="msg => speakerMessageClicked(msg)"
        />
      </v-menu>

      <v-btn :to="{name: 'finSpeaker'}"
             @click="finSpeakerClicked"
             class="mr-4"
             icon v-else>
        <v-icon class="nav-icon">icon-notification</v-icon>
      </v-btn>

      <v-menu offset-y>
        <template #activator="{on, attrs}">
          <div v-on.native="on" v-bind="attrs" @click="avatarClicked">
            <fin-avatar
              :avatar-size="48"
              disableTooltip
              :item="{}"
              avatar-border-color="transparent"
              class="mr-2">
              <fin-profile-img :dark="!dark"/>
            </fin-avatar>
          </div>
        </template>

        <v-list class="fin-profile-menu">
          <v-list-item :to="{name: 'myWatchlists'}">
            Meine Watchlists
          </v-list-item>
          <v-list-item :to="{name: 'myProfile'}">
            Profil verwalten
          </v-list-item>
          <v-divider/>
          <v-list-item>
            <fin-sign-out-btn/>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>

    <v-btn @click.stop="$emit('toggle')" icon v-else>
      <v-icon style="font-size: 28px">icon-menu</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import FinProfileImg from '@/components/pages/profile/ProfileImg'
import FinSpeakerMessages from '@/components/common/speaker/messages/index'
import {finSpeakerAPI} from '@/js/finAPI'
import FinSignOutBtn from '@/components/auth/SignOutBtn'
import {Wormhole} from 'portal-vue'
import FinAvatar from "@/components/common/avatar"
import FinAssetsNameIsinAutocomplete from "@/components/common/AssetsNameIsinAutocomplete"
import {mapGetters} from "vuex"
import SubscriptionHandler from "@/mixins/SubscriptionHandler"
import {speakerMessageSubscription} from "@/js/finSubscriptions"
import AmplitudePush from "@/mixins/AmplitudePush"
import finBrowser from "@/js/finBrowser"
import FinLanguageSwitcher from "@/components/navigation/LanguageSwitcher"

const map = (value, x1, y1, x2, y2) => (value - x1) * (y2 - x2) / (y1 - x1) + x2

export default {
  name: 'fin-top-navigation',
  mixins: [SubscriptionHandler, AmplitudePush],
  components: {
    FinLanguageSwitcher,
    FinAssetsNameIsinAutocomplete,
    FinSignOutBtn,
    FinSpeakerMessages,
    FinProfileImg,
    FinAvatar
  },
  data() {
    return {
      speakerMessages: [],
      speakerNextToken: null,
      prominentScrollEnd: 80,
      scrollPos: 0,
      subscriptionDone: false,
      isNewTab: this.$route.query.tab,
      hideLanguageSwitcher: process.env.VUE_APP_HIDE_LANGUAGE_SWITCHER === 'true'
    }
  },
  computed: {
    ...mapGetters('auth', ['userId']),
    maxScroll() {
      return this.scrollPos > this.prominentScrollEnd ? this.prominentScrollEnd : this.scrollPos
    },
    fontSize() {
      return this.prominent ? 14 + 18 - map(this.maxScroll, 0, this.prominentScrollEnd, 0, 18) : 14
    },
    marginTop() {
      return this.prominent ? -35 + map(this.maxScroll, 0, this.prominentScrollEnd, 0, 35) : 0
    },
    iconSpacing() {
      return this.prominent ? 4 - parseInt(map(this.maxScroll, 0, this.prominentScrollEnd, 0, 2), 10) : 2
    },
    transparency() {
      return this.$vuetify.breakpoint.mdAndUp && this.scrollPos < 85 ? 0 : 1
    },
    showSubPages() {
      return !this.isRoot && this.scrollPos > this.maxScroll
    },
    upperCase() {
      return !this.prominent || this.maxScroll >= this.prominentScrollEnd
    },
    border() {
      return !this.isRoot || this.isFinHub && this.scrollPos >= 85
    },
    crumbs() {
      let result = this.$route.matched
      result = result.filter(route => {
        return !route.meta.breadcrumbIgnore
      })
      if (Wormhole.hasContentFor('breadcrumb_append')) {
        result.push({name: 'append'})
      }
      return result
    },
    filteredCrumbs() {
      let result = this.crumbs.slice(-2) //last two or less
      if (!this.showSubPages && result.length > 1) {
        result = result.slice(0, 1)
      }
      return result
    },
    isRoot() {
      return this.crumbs.length < 2
    },
    currentCrumb() {
      return this.crumbs.length ? this.crumbs[this.crumbs.length - 1] : null
    },
    isFinHub() {
      return this.currentCrumb?.name === 'myFinHub'
    },
    hasExtension() {
      return Wormhole.hasContentFor('topnav_extension')
    },
    dark() {
      return this.isRoot && !this.isFinHub
    },
    prominent() {
      if (finBrowser.IS_IOS()) {
        return !finBrowser.IS_IOS()
      }

      return this.$vuetify.breakpoint.mdAndUp && this.dark
    },
    style() {
      const result = {
        zIndex: '30'
      }

      if (this.isFinHub) {
        result['background-color'] = `rgba(255, 255, 255, ${this.transparency}) !important`
      }
      return result
    },
  },
  methods: {
    closeWindow() {
      if (finBrowser.IS_IOS_OR_ANDROID_APP) {
        this.$router.go(-1)
      } else {
        window.close()
      }
    },
    onScroll() {
      this.scrollPos = window.scrollY
    },
    crumbName(crumbObj) {
      let resultIndex = null
      let result = null

      if (crumbObj.meta.breadcrumbName) {
        result = crumbObj.meta.breadcrumbName
        resultIndex = this.filteredCrumbs.findIndex(fc => fc.meta.breadcrumbName === result)
      } else {
        result = crumbObj.name
        resultIndex = this.filteredCrumbs.findIndex(fc => fc.name === result)
      }

      // if it's the first element => uppercase, else without modification, see FINDEV-2041
      return resultIndex === 0 ? result.toUpperCase() : result
    },
    handleSearchResult(result) {
      if (result) {
        // only navigate to the desired page if the user isn't already at this page => prevents router NavigationDuplicated errors
        if (result.assetClass === 'SHARE' && (this.$route.name === 'companyDetail' && this.$route.params.id !== result.id || this.$route.name !== 'companyDetail')) {
          this.$router.push({name: 'companyDetail', params: {id: result.id}})
        } else if (result.assetClass !== 'SHARE' && (this.$route.name === 'etfDetail' && this.$route.params.id !== result.id || this.$route.name !== 'etfDetail')) {
          this.$router.push({name: 'etfDetail', params: {id: result.id}})
        }
      }
    },
    customSearchResultMapping(searchResults) {
      return searchResults.map(sr => sr.instrument)
    },
    handleSubscription(newData, user) {
      const {id, createdAt, readAt, status, message} = newData.data.onSpeakerMessageRecipient

      // if readAt is set at subscription event => remove from unread list
      if (readAt) {
        this.speakerMessages = this.speakerMessages.filter(m => m.id !== id)

        // if there are more unread messages add them to the end of the list
        if (this.speakerNextToken) {
          this.loadUnreadSpeakerMessages(1)
        }
      }
      // readAt not set => add to top of unread list
      else {
        this.speakerMessages.unshift({id, createdAt, readAt, status, message})
      }
    },
    async loadUnreadSpeakerMessages(limit = 10) {
      // on xs the speaker messages are read at the SideNavigationMobile component
      if (this.$vuetify.breakpoint.smAndUp) {
        try {
          const result = await finSpeakerAPI.getUnreadMessages(this.userId, limit, this.speakerNextToken)
          console.log(result)
          this.speakerNextToken = result.nextToken
          // always put it at the end of the list
          this.speakerMessages = [...this.speakerMessages, ...result.items]
        } catch (e) {
          console.error('loadUnreadSpeakerMessages TODO handle search error', e)
        }

        if (!this.subscriptionDone) {
          this.subscribeToChanges(
            {id: this.userId},
            speakerMessageSubscription,
            (user) => {
              return {owner: user.id}
            },
            this.handleSubscription
          )
          this.subscriptionDone = true
        }
      }
    },
    speakerMessageClicked(msg) {
      // navigate to display page
      this.$router.push({name: 'finSpeaker', params: {msgId: msg.id}})
    },
    searchBarClicked() {
      this.pushToAmplitude({
        'event': 'fincraft_top_navi_autocomplete_search',
        'step': 'autocomplete_search',
        'placement': 'top_navi',
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })
    },
    finSpeakerClicked() {
      this.pushToAmplitude({
        'event': 'fincraft_top_navi_speaker',
        'step': 'autocomplete_speaker',
        'placement': 'top_navi',
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })
    },
    avatarClicked() {
      this.pushToAmplitude({
        'event': 'fincraft_top_navi_avatar',
        'step': 'autocomplete_avatar',
        'placement': 'top_navi',
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })
    }
  },
  beforeMount() {
    this.onScroll()
    this.loadUnreadSpeakerMessages()
  },
}
</script>

<style lang="scss" scoped>
.fin-top-navigation {

  box-shadow: none !important;

  ::v-deep .v-input__slot {
    min-height: unset !important;
  }

  ::v-deep .v-input__prepend-inner {
    margin: auto;
  }

  .fin-toolbartitle {
    overflow: inherit !important;
  }

  &.border {
    box-shadow: $fin-color-shadow !important;
  }

  .root-title {
    margin-top: -24px;
    letter-spacing: 1px;
    font-family: Gilroy;
  }

  .breadcrumbs {
    letter-spacing: 1px;

    ::v-deep li {
      max-width: 100%;
    }

    ::v-deep a.v-breadcrumbs__item {
      max-width: 100%;

      div {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    &::v-deep.theme--light a.v-breadcrumbs__item {
      color: $fin-color-primary-dark !important;
    }

    &::v-deep.theme--dark a.v-breadcrumbs__item {
      color: #eee !important;
    }
  }

  @media only screen and (max-width: 630px) {
    .breadcrumbs li {
      font-size: 9px !important;
    }
  }

  .search ::v-deep .v-input__append-inner {
    margin: 10px auto;
  }
}

.speaker-menu-content {
  overflow: hidden;
}
</style>
